import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from '../../servicios/config/config.service';
import { KeyService } from '../../servicios/key.service';
import { DatatablesService } from '../../servicios/datatable/datatables.service';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { RastreoService } from '../../servicios/rastreo/rastreo.service';
//Declaracion de variable global para usar jQuery
declare var $: any;
@Injectable()
export class FiltrosService {
    dTFiltros             :any;
    public marcas : any[] = [];
    PATH = new ConfigService().obtenerPath();
    headers = {};
    constructor(
      private http       : Http,
      private _config    : ConfigService,
      private _datatable : DatatablesService,
      private toastr     : ToastrService,
      private _rastreo   : RastreoService,
      private _key       : KeyService
    ) {
      this.headers =  this._key.head2();
    }

    obtenerFiltro(info = null,filtrodefault, modulo,validaEdit){
      // $('.filtro').val('');
      // $('#selectFiltro').html('');
      // $('#selectFiltro').html([]);
      // $('.chosen-select').val('').trigger('chosen:updated');
      let url = this.PATH + '/api/admin/obtenerfiltro/'+ info + '/' +  filtrodefault + '/' + modulo;
      // console.log(url);
      return this.http.get(url,{headers:this._key.head()}).map(resp => resp.json());
      // .subscribe(resp => {

      //   let totalFiltros = resp.data[0];
      //   let dataFiltro   = resp.data[1];

      //   let option =  '';
      //   for (let j = 0; j < totalFiltros.length; j++) {
      //     option += '<option value="'+totalFiltros[j].headfiltroid+'">'+totalFiltros[j].nombre+'<option>';
      //   }

      //   for (let j = 0; j < dataFiltro.length; j++) {
      //     if($('[data-modulo='+dataFiltro[j].campo+']').is("[multiple]")){
      //         $('[data-modulo='+dataFiltro[j].campo+']').val(dataFiltro[j].valor.split(',')).trigger('chosen:updated');
      //     }else{
      //         $('[data-modulo='+dataFiltro[j].campo+']').val(dataFiltro[j].valor).trigger('chosen:updated');
      //     }
      //   }

      //   $('#selectFiltro').html(option);

      //   if(dataFiltro.length > 0){
      //     if(validaEdit == 1){
      //       $('#headfiltroid').val(dataFiltro[0].headfiltroid);
      //       $('.nombre').removeClass('hide');
      //       $('#nombre').val(dataFiltro[0].nombre);
      //       $('#selectFiltro_chosen').addClass('hide');
      //     }else{
      //       $('#selectFiltro_chosen').removeClass('hide');
      //       $('.nombre').addClass('hide');
      //       $('#headfiltroid').val('');
      //       $('#nombre').val('');
      //       // console.log('dataFiltro[0].headfiltroid',dataFiltro[0].headfiltroid);
      //       $('#selectFiltro').val(dataFiltro[0].headfiltroid).trigger('chosen:updated');
      //     }
      //   }
      // });
    }

    updateDefaultFiltro(data) {
      let url = this.PATH + '/api/admin/updatedefaultfiltro';
      return this.http.post(url, data, {headers:this._key.head()}).map(resp => resp.json());
    }

    setFiltros(modulo:any,nombrefiltro:any,nuevoarray){
      let data = {
        data         : nuevoarray,
        modulo       : modulo,
        nombre       : nombrefiltro,
        headfiltroid : $('#headfiltroid').val()
      }

      let peticion:any;
      if($('#headfiltroid').val() == ''){
        let url = this.PATH + '/api/admin/filtrosSistema';
        peticion = this.http.post(url, data , {headers:this._key.head()}).map(resp => resp.json());
      }else{
        let url = this.PATH+'/api/admin/filtrosSistema/'+data.headfiltroid;
        peticion = this.http.put(url, data , {headers:this._key.head()}).map(resp => resp.json());
      }

      peticion.subscribe(res => {
        if (res.error){
          this.toastr.error(res.message, 'Error', { timeOut: 3000 });
          return;
        } else {
          if($('#headfiltroid').val() != ''){
            // $(".MFiltro").addClass('hide');
            // $("#dttableFiltro").removeClass('hide');
            // $('.btnAdministrarFiltro').click();
          }
          this.dTFiltros.ajax.reload();
          this.obtenerFiltro(data.headfiltroid,null,modulo,1);
          this.toastr.success('Transacción exitosa', '', { timeOut: 3000 });
        }
      });
    }

    crearFiltro(data: any) {
      let url = this.PATH + '/api/admin/filtrosSistema';
      return this.http.post(url, data , {headers:this._key.head()}).map(resp => resp.json());
    }

    editarFiltro(data: any) {
      let url = this.PATH+'/api/admin/filtrosSistema/'+data.headfiltroid;
      return this.http.put(url, data , {headers:this._key.head()}).map(resp => resp.json());
    }

    destroy(id:any){
      let url = this.PATH + '/api/admin/filtrosSistema/'+id+'/destroy';
      return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());
    }

    dataFiltros(modulo){
      let self = this;
      return  self.dTFiltros = $('#dTFiltros').DataTable( {
        dom: "<'row no-gutters pt-1 px-1'<'col-sm-12 col-md-12'f>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
        destroy: true,
        scrollX: true,
        language: self._datatable.language(),
        order : [[1,'desc']],
        buttons: self._datatable.buttons(),
        lengthChange :true,
        processing: true,
        serverSide: true,
        ajax: {
          url: self.PATH + '/api/admin/ListaFiltro',
          type: 'POST',
          headers : self.headers,
          data : function(d){
            return  $.extend(d,{modulo:modulo});
          },
        },
        columns: [
          { data: "headfiltroid" },
          { data: "nombre" },
          { data: "usuarioid" },
        ],
        initComplete: function(settings, json){
          var self = this;
          $(this).closest('.dataTables_wrapper').find('div.dataTables_filter input').unbind().keyup( function (e) {
            e.preventDefault();
            if (e.keyCode == 13) {
              self.dtTblIncidencia = $("body").find(self.dtTblIncidencia).dataTable();
              self.dtTblIncidencia.fnFilter( this.value );
              self.fnFilter(this.value);
            };
          } );
          $('div.dataTables_filter input').focus();
        },
        columnDefs: [
          {
            targets 	: [0],
            width 		: '1%',
            order     : false,
            className : 'center'
          },
          {
            targets 	: [1],
            width 		: '50%',
            order     : true,
            className : 'center'
          }
        ],
        rowCallback : function(row,data){
          let btnEditar          = '';
          let btnEliminar        = '';

          btnEliminar = '<a class="btnEliminar btn btn-danger glyphicon glyphicon-remove" type="submit" style="width:30px; padding:1px;"></a>';
          btnEditar   = '<a class="btnEditar btn btn-success glyphicon glyphicon-pencil" type="submit" title="Editar Incidencia"  style="width:30px; padding:1px;"></a>';
          $(row).find('td:eq(0)').html( btnEditar + '' + btnEliminar);
          $(row).find('.btnEliminar').on("click", function(e){
            e.preventDefault();

            $(row).on("click", ".btnEliminar", function(e){
              e.preventDefault();
              self.enviarEliminar(data.headfiltroid,data.nombre)
            });
          });

          $(row).find('.btnEditar').on("click", function(e){
            $("#dttableFiltro").addClass('hide');
            $(".clasbtnFiltro").removeClass('hide');
            self.obtenerFiltro(data.headfiltroid,null,modulo,1);
          });

        },
        createdRow: function(row, data, index){
        },
      });
    }

      /**
     * Permite enviar la petición a un servicio para eliminar el registro
     * CAAA-2018-12-06
     */
    enviarEliminar(headfiltroid, nombre){
      swal({
        title: 'Esta seguro de eliminar el registro?',
        text: "",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          this.destroy(headfiltroid).subscribe((resp) => {
            if (resp.error) {
              this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
            } else {
              //rastreo
              let opcionEnviar = 'Elimina Filtro: Codigo: '+ headfiltroid + ' Nombre: '+ nombre;
              this._rastreo.setRastreo(opcionEnviar,'Tipo Instalacion').subscribe((resp)=>{
              })//fin rastreo
              this.toastr.success(resp.message, '', { timeOut: 3000 });
              $('#dTFiltroAvanzado').DataTable().ajax.reload();
              this.dTFiltros.ajax.reload();
            }
          });
        } // .if (result.value)
      });
    }// .enviarEliminar()


    validarNombre(data:any){
      let url = this.PATH+'/api/admin/validarNombre';
      return this.http.post(url, data, {headers:this._key.head()}).map( resp => resp.json());
    }


    guardarFiltros(modulo){
        var nuevoarray = [];
        $("#filtroAvanzado").find('.filtro').each(function(){
          if($(this).is("[multiple]")){
            for (let i=0; i < $(this).val().length; i++) {
              nuevoarray.push({campo:$(this).attr('data-modulo'), valor: $(this).select2('data')[i].id, texto: $(this).select2('data')[i].text});
            }
          }else{
            if($(this).val()){
              nuevoarray.push({campo:$(this).attr('data-modulo'), valor: $(this).val(), texto: null});
            }
          }
        });
        // console.log(nuevoarray);
        let self = this;
        swal({
        title: 'Digite nombre filtro',
        input: 'text',
        inputValue : $('#nombre').val(),
        inputAttributes: {
          maxlength     : '30',
          autocapitalize: 'off',
          autocorrect   : 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        showLoaderOnConfirm: true,
        preConfirm: (nombre) => {
          let data = {
            nombre : nombre,
            headfiltroid : $('#headfiltroid').val(),
          }

          var form_data = new FormData();
          for (var key in data) {
            form_data.append(key, data[key]);
          }

          let url = this.PATH+'/api/admin/validarNombre';
          let request = new Request(url,
            {
              method: 'POST',
              body : form_data,
              headers : new Headers(this.headers),
              mode: 'cors',
              credentials: 'omit',
              redirect: 'follow',
              referrerPolicy: 'no-referrer',
              cache: 'no-cache'
            });
          return fetch(
            request
          )
          .then(response => {
              return response.json().then(data => {
                  if(data.data == 1){
                    swal.showValidationMessage(
                      `Verificar nombre: ${data.message}`
                    )
                  }
              });
          })
          .catch(error => {
            swal.showValidationMessage(
              `Request failed : ${error}`
            )
          })
        },
        allowOutsideClick: () => !swal.isLoading()
        }).then(result => {
          if(result.value){
            $('.btnAdministrarFiltro').click();
            this.setFiltros(modulo,result.value,nuevoarray);
          }
        });
    }

    // especial para agendamiento
    obtenerFiltroAgenda(info = null,filtrodefault, modulo){
      $('.filtro').val('');
      $('#selectFiltro').html('');
      let url = this.PATH + '/api/admin/obtenerfiltro/'+info + '/' +  filtrodefault + '/' + modulo;
      return this.http.get(url,{headers:this._key.head()}).map(resp => resp.json());
    }

    iniciarFiltros(arrayFiltros: any[]) {
      arrayFiltros.forEach(f => this.FiltroSelect2(f.tipoFiltro, f.opcion));
    }

    FiltroSelect2(tipoFiltro = null,opcion = 1, almacendescarga = null){
      let self = this;
      if(opcion){
        $("."+tipoFiltro).select2({
          language : {
            noResults:function(){
              return 'No hay Resultado';
            },
            searching:function(){
              return 'Buscando..';
            },
            inputTooShort: function (){
              return 'Se necesitan mas de dos caracteres'
            },
          },
          tags: false,
          multiple: true,
          minimumInputLength: 2,
          width: '100%',
          ajax: {
              url: self.PATH + '/api/admin/FiltroSelect2',
              dataType: "json",
              type: "POST",
              delay:250,
              headers : self.headers,
              data: function (params) {
                return {
                  searchTerm: params.term,// search term
                  tipoFiltro, //tipo de fltro a solicitar
                  almacendescarga //Solo se usa para buscar productos en ERPFive
                };
              },
              processResults: function (data) {
                  return {
                      results: $.map(data.data, function (item) {
                          return {
                            text: item.text,
                            id: item.id
                          }
                      })
                  };
              },
            }
        });
        // $(document).off('keyup','.select2-search__field').on('keyup','.select2-search__field',function(e) {
        //   let resul =  2 - (this.value.length);
        //   if(this.value.length < 2){
        //     $('.select2-results__option').text('Ingrese mínimo ' + resul + ' caracteres');
        //   }
        // });

        // $(document).off('click','.select2-selection--multiple').on('click','.select2-selection--multiple',function(e) {
        //   $('.select2-results__option').text('Ingrese mínimo 2 caracteres');
        // });
      }else{
        $("."+tipoFiltro).select2({
          language : {
            noResults:function(){
              return 'No hay Resultado';
            },
            searching:function(){
              return 'Buscando..';
            }
          },
          multiple: true,
          tags: false,
          ajax: {
              url: self.PATH + '/api/admin/FiltroSelect2',
              dataType: "json",
              type: "POST",
              delay:250,
              headers : self.headers,
              data: function (params) {
                return {
                  searchTerm: params.term,// search term
                  tipoFiltro, //tipo de fltro a solicitar
                  almacendescarga //Solo se usa para buscar productos en ERPFive
                };
              },
              processResults: function (data) {
                  return {
                      results: $.map(data.data, function (item) {
                          return {
                            text: item.text,
                            id: item.id
                          }
                      })
                  };
              },
            }
        });
      }

    }

    filtroSelectAvanzado(tipoFiltro, cadenaFiltros) {
      let self = this;
      $("." + tipoFiltro).select2({
        language : {
          noResults:function(){
            return 'No hay Resultado';
          },
          searching:function(){
            return 'Buscando..';
          },
          inputTooShort: function (){
            return 'Se necesitan mas de dos caracteres'
          },
        },
        tags: false,
        multiple: true,
        minimumInputLength: 2,
        ajax: {
            url: self.PATH + '/api/admin/filtroSelectAvanzado',
            dataType: "json",
            type: "POST",
            delay: 250,
            headers : self.headers,
            data: function (params) {
              return {
                searchTerm: params.term,// search term
                tipoFiltro, //tipo de fltro a solicitar
                cadenaFiltros
              };
            },
            processResults: function (data) {
                return {
                    results: $.map(data.data, function (item) {
                        return {
                          text: item.text,
                          id: item.id
                        }
                    })
                };
            },
          }
      });
    }

}






// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/filtro/filtros.service.ts